export default "https://assets.pclncdn.com/web/next-landing/b9d3836/_next/static/images/pcln-hp-hero-freedom-ee45877ee9c778177ff36f9529de57dc.jpg";